/* ============================================================
   Packages mega menu (desktop) + mobile menu + menu search.
   Markup is generated by tools/build-nav.js. No dependencies.

   Desktop: WAI-ARIA disclosure pattern. Opens on hover (mouse,
   with a short delay) or click/Enter; closes on Escape, a click
   outside, focus leaving the menu, or the pointer leaving after a
   hover-open. A click while hover-opened pins it open.

   Mobile: modal dialog with three views (main, packages, search),
   focus kept inside, Escape closes, focus returns to the opener.
   ============================================================ */
(function () {
    'use strict';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktopMq = window.matchMedia('(min-width: 992px)');
    var OPEN_DELAY = 120;
    var CLOSE_DELAY = 250;
    var ANIM_MS = 320;

    function onChange(mq, fn) {
        if (mq.addEventListener) mq.addEventListener('change', fn);
        else if (mq.addListener) mq.addListener(fn);   // Safari < 14
    }

    function animMs() {
        return reduceMotion.matches ? 0 : ANIM_MS;
    }

    function isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    /* ════════════════════════════════════════════════════════
       SEARCH — suggestions from assets/json/nav-search.json
    ════════════════════════════════════════════════════════ */

    var indexCache = {};

    function loadIndex(url) {
        if (!indexCache[url]) {
            indexCache[url] = fetch(url, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) throw new Error('HTTP ' + r.status);
                    return r.json();
                })
                .then(function (d) { return Array.isArray(d.items) ? d.items : []; })
                .catch(function () {
                    delete indexCache[url];                 // allow a retry later
                    return null;
                });
        }
        return indexCache[url];
    }

    function norm(s) {
        s = String(s).toLowerCase();
        return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
    }

    var KIND_ORDER = { d: 0, t: 1, p: 2 };
    var KIND_LABEL = { d: 'Destination', t: 'Theme', p: 'Package' };
    var MAX_RESULTS = 7;

    function searchItems(items, query) {
        var q = norm(query).trim();
        var words = q.split(/\s+/).filter(Boolean);
        if (!words.length) return [];
        var out = [];
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            var hay = it.h || norm(it.t);
            var ok = true;
            for (var w = 0; w < words.length; w++) {
                if (hay.indexOf(words[w]) < 0) { ok = false; break; }
            }
            if (!ok) continue;
            var title = norm(it.t);
            var score = title.indexOf(q) === 0 ? 0
                : (' ' + title).indexOf(' ' + words[0]) >= 0 ? 1
                : norm(it.s || '').indexOf(q) === 0 ? 1.5   // theme whose examples start with it
                : 2;
            out.push({ it: it, score: score });
        }
        out.sort(function (a, b) {
            return a.score - b.score ||
                KIND_ORDER[a.it.k] - KIND_ORDER[b.it.k] ||
                a.it.t.localeCompare(b.it.t);
        });
        return out.slice(0, MAX_RESULTS).map(function (r) { return r.it; });
    }

    function setupSearch(form) {
        var input = form.querySelector('.mm-search-input');
        var list = form.querySelector('[role="listbox"]');
        var empty = form.querySelector('[data-mm-empty]');
        var emptyText = form.querySelector('[data-mm-empty-text]');
        var status = form.querySelector('[data-mm-status]');
        var indexUrl = form.getAttribute('data-index');
        var defaultAction = form.getAttribute('action');
        if (!input || !list || !indexUrl) return null;

        var results = [];
        var active = -1;
        var timer = null;
        var seq = 0;

        function setExpanded(open) {
            list.hidden = !open;
            input.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (!open) {
                active = -1;
                input.removeAttribute('aria-activedescendant');
            }
        }

        function closeList() {
            setExpanded(false);
            if (empty) empty.hidden = true;
        }

        function render(query) {
            active = -1;                                    // old index may not exist in the new list
            input.removeAttribute('aria-activedescendant');
            list.innerHTML = '';
            results.forEach(function (r, i) {
                var a = document.createElement('a');
                a.className = 'mm-result';
                a.id = list.id + '-' + i;
                a.href = r.u;
                a.tabIndex = -1;
                a.setAttribute('role', 'option');
                a.setAttribute('aria-selected', 'false');

                var kind = document.createElement('span');
                kind.className = 'mm-result-kind mm-result-kind--' + r.k;
                kind.textContent = KIND_LABEL[r.k] || '';
                var text = document.createElement('span');
                text.className = 'mm-result-text';
                var t = document.createElement('span');
                t.className = 'mm-result-title';
                t.textContent = r.t;
                var s = document.createElement('span');
                s.className = 'mm-result-sub';
                s.textContent = r.s || '';
                text.appendChild(t);
                text.appendChild(s);
                a.appendChild(kind);
                a.appendChild(text);
                list.appendChild(a);
            });
            setExpanded(results.length > 0);
            if (empty) {
                empty.hidden = results.length > 0;
                if (!results.length && emptyText) emptyText.textContent = 'No packages match “' + query + '”.';
            }
            if (status) {
                status.textContent = results.length
                    ? results.length + (results.length === 1 ? ' suggestion' : ' suggestions') + ' available.'
                    : 'No suggestions.';
            }
        }

        function update() {
            var query = input.value.trim();
            var mySeq = ++seq;
            if (query.length < 2) {
                results = [];
                closeList();
                if (status) status.textContent = '';
                return;
            }
            loadIndex(indexUrl).then(function (items) {
                if (mySeq !== seq) return;                  // a newer keystroke won
                if (!items) {                               // index unavailable: plain search still works
                    results = [];
                    closeList();
                    return;
                }
                results = searchItems(items, query);
                render(query);
            });
        }

        function move(delta) {
            var opts = list.querySelectorAll('[role="option"]');
            if (!opts.length) return;
            if (active >= 0) {
                opts[active].classList.remove('is-active');
                opts[active].setAttribute('aria-selected', 'false');
            }
            active = active < 0
                ? (delta > 0 ? 0 : opts.length - 1)
                : (active + delta + opts.length) % opts.length;
            var cur = opts[active];
            cur.classList.add('is-active');
            cur.setAttribute('aria-selected', 'true');
            input.setAttribute('aria-activedescendant', cur.id);
            if (cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
        }

        /** Domestic listing unless every match is international. */
        function pickAction() {
            var intl = form.getAttribute('data-intl-action');
            if (!intl || !results.length) return defaultAction;
            var allIntl = results.every(function (r) { return r.sc === 'i'; });
            return allIntl ? intl : defaultAction;
        }

        input.addEventListener('focus', function () { loadIndex(indexUrl); });  // warm up
        input.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(update, 120);
        });

        input.addEventListener('keydown', function (e) {
            var open = !list.hidden;
            if (e.key === 'ArrowDown' || e.key === 'Down') {
                if (results.length) {
                    e.preventDefault();
                    if (!open) setExpanded(true);
                    move(1);
                }
            } else if (e.key === 'ArrowUp' || e.key === 'Up') {
                if (open) {
                    e.preventDefault();
                    move(-1);
                }
            } else if (e.key === 'Enter') {
                if (open && active >= 0 && results[active]) {
                    e.preventDefault();
                    window.location.href = results[active].u;
                }
            } else if (e.key === 'Escape' || e.key === 'Esc') {
                if (open || (empty && !empty.hidden)) {
                    e.preventDefault();
                    e.stopPropagation();                    // don't close the whole menu yet
                    closeList();
                }
            }
        });

        form.addEventListener('submit', function (e) {
            if (!input.value.trim()) {
                e.preventDefault();
                input.focus();
                return;
            }
            form.setAttribute('action', pickAction());
        });

        // Clicks inside the form keep the list; anything else closes it.
        document.addEventListener('pointerdown', function (e) {
            if (!form.contains(e.target)) closeList();
        });
        form.addEventListener('focusout', function (e) {
            if (e.relatedTarget && !form.contains(e.relatedTarget)) closeList();
        });

        return { input: input, close: closeList };
    }

    var searches = [];
    document.querySelectorAll('form[data-mm-search]').forEach(function (form) {
        var s = setupSearch(form);
        if (s) searches.push(s);
    });

    function closeSearchLists() {
        searches.forEach(function (s) { s.close(); });
    }

    /* ════════════════════════════════════════════════════════
       DESKTOP — Packages mega menu
    ════════════════════════════════════════════════════════ */

    (function setupDesktop() {
        var item = document.querySelector('.mm-item');
        var trigger = item && item.querySelector('.mm-trigger');
        var panel = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;

        var openTimer = null;
        var closeTimer = null;
        var hideTimer = null;
        var openedBy = null;          // 'hover' | 'click' | 'key'

        function isOpen() {
            return trigger.getAttribute('aria-expanded') === 'true';
        }

        function fitHeight() {
            var top = panel.getBoundingClientRect().top;
            panel.style.setProperty('--mm-max', Math.max(260, window.innerHeight - top - 16) + 'px');
        }

        function clearTimers() {
            clearTimeout(openTimer);
            clearTimeout(closeTimer);
            clearTimeout(hideTimer);
        }

        function open(by) {
            clearTimers();
            openedBy = by;
            if (isOpen()) return;
            panel.hidden = false;
            fitHeight();
            trigger.setAttribute('aria-expanded', 'true');
            void panel.offsetWidth;                         // start the transition from the hidden state
            item.classList.add('is-open');
        }

        function close(returnFocus) {
            clearTimers();
            if (!isOpen()) return;
            openedBy = null;
            trigger.setAttribute('aria-expanded', 'false');
            item.classList.remove('is-open');
            closeSearchLists();
            if (returnFocus) trigger.focus();
            hideTimer = setTimeout(function () {
                if (!isOpen()) panel.hidden = true;
            }, reduceMotion.matches ? 0 : 220);
        }

        function closeNow() {
            close(false);
            clearTimeout(hideTimer);
            panel.hidden = true;
        }

        trigger.addEventListener('click', function () {
            if (!isOpen()) open('click');
            else if (openedBy === 'hover') openedBy = 'click';   // pin it open
            else close(false);
        });

        trigger.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || e.key === 'Down') {
                e.preventDefault();
                open('key');
                var first = panel.querySelector('.mm-search-input');
                if (first) first.focus();
            }
        });

        item.addEventListener('pointerenter', function (e) {
            if (e.pointerType !== 'mouse' || !desktopMq.matches) return;
            clearTimeout(closeTimer);
            if (!isOpen()) openTimer = setTimeout(function () { open('hover'); }, OPEN_DELAY);
        });

        item.addEventListener('pointerleave', function (e) {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(openTimer);
            if (!isOpen() || openedBy !== 'hover') return;
            closeTimer = setTimeout(function () {
                // keep it open while the visitor is typing in the search box
                if (!panel.contains(document.activeElement)) close(false);
            }, CLOSE_DELAY);
        });

        // Tabbing out of the menu closes it.
        item.addEventListener('focusout', function (e) {
            if (isOpen() && e.relatedTarget && !item.contains(e.relatedTarget)) close(false);
        });

        document.addEventListener('pointerdown', function (e) {
            if (isOpen() && !item.contains(e.target)) close(false);
        });

        document.addEventListener('keydown', function (e) {
            if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) {
                var inside = item.contains(document.activeElement);
                close(inside);
            }
        });

        window.addEventListener('resize', function () {
            if (isOpen()) fitHeight();
        });
        window.addEventListener('scroll', function () {
            if (isOpen()) fitHeight();                      // header shrinks when it turns sticky
        }, { passive: true });

        onChange(desktopMq, function () {
            if (!desktopMq.matches) closeNow();
        });

        // Back/forward cache: never restore the page with the menu open.
        window.addEventListener('pageshow', function (e) {
            if (e.persisted) closeNow();
        });

        // A menu link to this same page (e.g. /domestic-packages.html#type=hills while
        // already on that page) only changes the fragment: close so the result shows.
        window.addEventListener('hashchange', function () {
            if (isOpen()) close(false);
        });
    })();

    /* ════════════════════════════════════════════════════════
       MOBILE — drawer with main / packages / search views
    ════════════════════════════════════════════════════════ */

    (function setupDrawer() {
        var drawer = document.getElementById('mmDrawer');
        if (!drawer) return;

        var openers = document.querySelectorAll('[data-mm-open]');
        var views = {};
        drawer.querySelectorAll('[data-mm-view]').forEach(function (v) {
            views[v.getAttribute('data-mm-view')] = v;
        });

        var current = null;
        var lastOpener = null;
        var hideTimer = null;

        function eachView(fn) {
            Object.keys(views).forEach(function (k) { fn(views[k], k); });
        }

        function isOpen() {
            return !drawer.hidden && drawer.classList.contains('is-open');
        }

        function setOpeners(expanded) {
            openers.forEach(function (b) {
                b.setAttribute('aria-expanded', expanded && b === lastOpener ? 'true' : 'false');
            });
        }

        function showView(name, animate) {
            var next = views[name];
            if (!next || next === current) return;
            var prev = current;
            current = next;
            var forward = name !== 'main';

            next.hidden = false;
            if (animate && prev && animMs()) {
                next.classList.remove('is-left', 'is-right');
                next.classList.add(forward ? 'is-right' : 'is-left');
                void next.offsetWidth;
                next.classList.remove('is-left', 'is-right');
                prev.classList.add(forward ? 'is-left' : 'is-right');
                setTimeout(function () {
                    if (prev !== current) {
                        prev.hidden = true;
                        prev.classList.remove('is-left', 'is-right');
                    }
                }, animMs());
            } else {
                eachView(function (v) {
                    v.classList.remove('is-left', 'is-right');
                    if (v !== next) v.hidden = true;
                });
            }

            drawer.querySelectorAll('[data-mm-go]').forEach(function (b) {
                b.setAttribute('aria-expanded', b.getAttribute('data-mm-go') === name ? 'true' : 'false');
            });
        }

        function focusView(name) {
            var v = views[name];
            if (!v) return;
            var target = name === 'search'
                ? v.querySelector('.mm-search-input')
                : name === 'main' ? v.querySelector('.mm-close') : v.querySelector('.mm-sheet-title');
            if (target) target.focus({ preventScroll: true });
        }

        function openDrawer(name, opener) {
            clearTimeout(hideTimer);
            lastOpener = opener || null;
            drawer.hidden = false;
            document.documentElement.classList.add('mm-lock');
            showView(name, false);
            void drawer.offsetWidth;
            drawer.classList.add('is-open');
            setOpeners(true);
            focusView(name);
        }

        function closeDrawer(restoreFocus) {
            if (drawer.hidden) return;
            drawer.classList.remove('is-open');
            document.documentElement.classList.remove('mm-lock');
            setOpeners(false);
            closeSearchLists();
            clearTimeout(hideTimer);
            hideTimer = setTimeout(function () {
                drawer.hidden = true;
                eachView(function (v) {
                    v.hidden = true;
                    v.classList.remove('is-left', 'is-right');
                });
                current = null;
            }, animMs());
            if (restoreFocus !== false && lastOpener && isVisible(lastOpener)) lastOpener.focus();
        }

        function closeNow() {
            closeDrawer(false);
            clearTimeout(hideTimer);
            drawer.hidden = true;
            eachView(function (v) { v.hidden = true; v.classList.remove('is-left', 'is-right'); });
            current = null;
        }

        openers.forEach(function (b) {
            b.addEventListener('click', function () {
                openDrawer(b.getAttribute('data-mm-open') || 'main', b);
            });
        });

        drawer.addEventListener('click', function (e) {
            var t = e.target;
            if (t.closest('[data-mm-close]')) {
                closeDrawer();
                return;
            }
            var go = t.closest('[data-mm-go]');
            if (go) {
                showView(go.getAttribute('data-mm-go'), true);
                focusView(go.getAttribute('data-mm-go'));
                return;
            }
            if (t.closest('[data-mm-back]')) {
                var from = current && current.getAttribute('data-mm-view');
                showView('main', true);
                var back = from && views.main.querySelector('[data-mm-go="' + from + '"]');
                if (back) back.focus({ preventScroll: true });
                else focusView('main');
                return;
            }
            // A link to a spot on this same page: close so the target is visible
            // (the hashchange listener below covers fragment-only navigation too).
            var link = t.closest('a[href]');
            if (link && link.target !== '_blank' && link.hash &&
                link.pathname === window.location.pathname && link.search === window.location.search) {
                closeDrawer(false);
            }
        });

        // Tabs (Domestic / International)
        var tabs = Array.prototype.slice.call(drawer.querySelectorAll('[role="tab"]'));

        function selectTab(tab, focus) {
            tabs.forEach(function (t) {
                var on = t === tab;
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                t.tabIndex = on ? 0 : -1;
                var pane = document.getElementById(t.getAttribute('aria-controls'));
                if (pane) pane.hidden = !on;
            });
            if (focus) tab.focus();
        }

        tabs.forEach(function (tab, i) {
            tab.addEventListener('click', function () { selectTab(tab, false); });
            tab.addEventListener('keydown', function (e) {
                var next = null;
                if (e.key === 'ArrowRight' || e.key === 'Right') next = tabs[(i + 1) % tabs.length];
                else if (e.key === 'ArrowLeft' || e.key === 'Left') next = tabs[(i - 1 + tabs.length) % tabs.length];
                else if (e.key === 'Home') next = tabs[0];
                else if (e.key === 'End') next = tabs[tabs.length - 1];
                if (next) {
                    e.preventDefault();
                    selectTab(next, true);
                }
            });
        });

        // On international pages, open the Packages view on the International tab.
        if (/international-packages/.test(window.location.pathname)) {
            var intlTab = tabs.filter(function (t) { return t.getAttribute('data-mm-tab') === 'international'; })[0];
            if (intlTab) selectTab(intlTab, false);
        }

        // Keyboard: Escape closes; Tab stays inside the open view.
        drawer.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
                e.preventDefault();
                closeDrawer();
                return;
            }
            if (e.key !== 'Tab' || !current) return;
            var items = Array.prototype.filter.call(current.querySelectorAll(FOCUSABLE), isVisible);
            if (!items.length) return;
            var first = items[0];
            var last = items[items.length - 1];
            var active = document.activeElement;
            var inside = current.contains(active) && items.indexOf(active) >= 0;
            if (e.shiftKey && (active === first || !inside)) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && (active === last || !inside)) {
                e.preventDefault();
                first.focus();
            }
        });

        onChange(desktopMq, function () {
            if (desktopMq.matches) closeNow();
        });

        window.addEventListener('pageshow', function (e) {
            if (e.persisted) {
                closeNow();
                document.documentElement.classList.remove('mm-lock');
            }
        });

        window.addEventListener('hashchange', function () {
            if (!drawer.hidden) closeDrawer(false);
        });
    })();
})();
